export const QUESTIONNAIRE_CRITICALITY_CONFIG_V1 = 'QUESTIONNAIRE_CRITICALITY_CONFIG_V1';

export type QuestionnaireCriticalityConfigV1 = {
  criticalQuestionCodes: string[];
  isCriticalQuestion: (questionCode: string) => boolean;
};

export const isCriticalQuestionFallback = (_questionCode: string): boolean => false;
